import { Tag } from '@weave/schema-gen-ts/dist/schemas/tag/shared/v1/models.pb';
import { i18next } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import { sanitizePhoneNumber } from '@frontend/phone-numbers';
import { CallRecordsFiltersType } from '../../hooks/use-phone-config-state-store';
import { getFormattedCallerName } from '../../utils';
import { HydratedCallRecord } from '../all-calls/types';

export const getFallbackCallerName = (contactNumber?: string): string => {
  const sanitizedNumber = sanitizePhoneNumber(contactNumber ?? '');
  return !!sanitizedNumber ? getFormattedCallerName(sanitizedNumber) : i18next.t('Unknown', { ns: 'calls' });
};

export const getShortHandName = (callInfo: HydratedCallRecord): string => {
  const { callerNumber, person } = callInfo;
  return person ? getFullName(person) : getFallbackCallerName(callerNumber);
};

export const getRecentCallsSearchQuery = (
  filters: CallRecordsFiltersType | undefined,
  pageSize: number,
  mappedTags: Record<string, Tag>
) => `${JSON.stringify({ ...filters })}-${pageSize}-${Object.keys(mappedTags || {}).length}`;
